import { render, staticRenderFns } from "./SidebarActionPanel.vue?vue&type=template&id=64c60204&scoped=true"
import script from "./SidebarActionPanel.vue?vue&type=script&lang=js"
export * from "./SidebarActionPanel.vue?vue&type=script&lang=js"
import style0 from "./SidebarActionPanel.vue?vue&type=style&index=0&id=64c60204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c60204",
  null
  
)

export default component.exports